import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
import { LOGO_URL } from '../mock';

// Static link data — declared outside the component so the array references
// stay stable across renders and don't force FooterCol to re-render.
const EXPLORE_LINKS = [
  { label: 'Menu', href: '#menu' },
  { label: 'How it works', href: '#how' },
  { label: 'Catering', href: '#catering' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'About', href: '#about' },
];

const SERVICE_LINKS = [
  { label: 'Office Catering', href: '#menu' },
  { label: 'Meal Delivery', href: '#menu' },
  { label: 'Fridge Program', href: '#fridge' },
  { label: 'Catering Inquiry', href: '/catering-inquiry' },
  { label: 'Wedding Catering', href: '/catering-inquiry' },
  { label: 'Corporate Events', href: '/catering-inquiry' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1B2A22] text-[#D7DBC8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <div className="bg-[#F6F2E8] rounded-2xl p-2 inline-block">
                <img src={LOGO_URL} alt="Wholesome 360 logo" className="h-10 w-auto" />
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed max-w-md">
              Mediterranean-inspired healthy catering & meal delivery, made fresh every morning in West Town, Chicago for 10 years.
            </p>
            <div className="mt-6 flex gap-2">
              <SocialLink href="https://instagram.com/wholesome360eats" label="Instagram"><Instagram className="w-4 h-4" /></SocialLink>
              <SocialLink href="https://facebook.com" label="Facebook"><Facebook className="w-4 h-4" /></SocialLink>
            </div>
          </div>

          <FooterCol title="Explore" links={EXPLORE_LINKS} />

          <FooterCol title="Service" links={SERVICE_LINKS} />

          <div className="md:col-span-3">
            <h3 className="text-[#F6F2E8] font-semibold text-sm uppercase tracking-wider mb-4">Visit</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-2.5"><MapPin className="w-4 h-4 text-[#E8C56B] shrink-0 mt-0.5" /><span>324 N. Leavitt Street<br />Chicago, IL 60612</span></li>
              <li className="flex gap-2.5"><Phone className="w-4 h-4 text-[#E8C56B] shrink-0 mt-0.5" /><a href="tel:7738570230" className="hover:text-[#F6F2E8]">773-857-0230</a></li>
              <li className="flex gap-2.5"><Mail className="w-4 h-4 text-[#E8C56B] shrink-0 mt-0.5" /><a href="mailto:info@wholesome360.com" className="hover:text-[#F6F2E8]">info@wholesome360.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#9C9686]">
          <div>© {new Date().getFullYear()} Wholesome 360 Catering. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-[#F6F2E8]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#F6F2E8]">Terms</Link>
            <Link to="/accessibility" className="hover:text-[#F6F2E8]">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <h3 className="text-[#F6F2E8] font-semibold text-sm uppercase tracking-wider mb-4">{title}</h3>
      <ul className="space-y-2.5 text-sm">
        {links.map((l) => (
          <li key={l.label + l.href}>
            {l.href.startsWith('/') ? (
              <Link to={l.href} className="hover:text-[#F6F2E8] transition-colors">{l.label}</Link>
            ) : (
              <a href={l.href} className="hover:text-[#F6F2E8] transition-colors">{l.label}</a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

function SocialLink({ href, label, children }) {
  return (
    <a href={href} aria-label={label} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/15 grid place-items-center hover:bg-[#245A40] hover:border-[#245A40] hover:text-[#F6F2E8] transition-colors">
      {children}
    </a>
  );
}
